import { useI18n } from 'vue-i18n';

export const currency = (value: number) => {
  const { n } = useI18n();
  return n(value / 100, 'currency', 'nl');
};
